export default __webpack_public_path__ + "img/MYMY-logo-black.svg";